<div class="accordion">
    <div class="accordion__title" (click)="toggle()">
        <ng-content select=".title"></ng-content>
        <div class="accordion__chevron" [class.open]="isOpen()"></div>
    </div>
    <div class="accordion__details" [class.open]="isOpen()">
        <div>
            <ng-content select=".details"></ng-content>
        </div>
    </div>
</div>
